class InfoDocComponent {
  constructor(AuthService, InfoDocService, $element, $window, $timeout) {
    'ngInject';
    this.ids = InfoDocService;
    this.as = AuthService;
    this.$element = $element;
    this.$window = $window;
    this.$timeout = $timeout;
  }

  async $onInit() {
    this.provider = await this.as.provider();
    this.entry = this.ids.getEntry(this.provider, this.key);
    this.$timeout(_ => this.$element.find('.menu-info').tooltip({container: 'body'}), 1000);
  }

  openLink() {
    this.entry.link && this.$window.open(this.entry.link, '_blank');
  }

}

export default {
  bindings: {
    key: "<",
    infoText: "<"
  },
  templateUrl: 'form-builder/info-doc/info-doc.component.html',
  controller: InfoDocComponent
};
